import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import css from './SectionBlogs.module.css';
import { useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import locationImg1 from '../../../assets/FeaturedBlogs/blog1.jpg';
import locationImg2 from '../../../assets/FeaturedBlogs/blog2.jpg';
import locationImg3 from '../../../assets/FeaturedBlogs/blog3.jpg';
import { ExternalLink, Icons, ListingCard, PrimaryButton } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { searchListings } from '../../SearchPage/SearchPage.duck';
import { useConfiguration } from '../../../context/configurationContext';
import { getListingsById } from '../../../ducks/marketplaceData.duck';
import { cardRenderSizes } from '../../SearchPage/SearchResultsPanel/SearchResultsPanel';
import { getSearchParams } from '../../../util/genericHelpers';
import { MdAddLocationAlt, MdSupervisorAccount } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';

function SectionBecomeHost() {
  const intl = useIntl();
  const history = useHistory();

  const handleClick = () => {
    history.push(createResourceLocatorString('NewListingPage', routeConfiguration(), {}, {}));
  };

  return (
    <div className={css.sectionBecomeHost}>
      <div className={css.fixedWidthContainer}>
        <div className={css.becomeHostStart}>
          <h2>{intl.formatMessage({ id: 'SectionBecomeHost.title' })}</h2>
          <div className={css.steps}>
            <div className={css.step}>
              <MdSupervisorAccount size={24} color="#0d31f2" />
              <div className={css.stepInfo}>
                <h3>{intl.formatMessage({ id: 'SectionBecomeHost.step1.title' })}</h3>
                <p>{intl.formatMessage({ id: 'SectionBecomeHost.step1.description' })}</p>
              </div>
            </div>
            <div className={css.step}>
              <MdAddLocationAlt size={24} color="#0d31f2" />
              <div className={css.stepInfo}>
                <h3>{intl.formatMessage({ id: 'SectionBecomeHost.step2.title' })}</h3>
                <p>{intl.formatMessage({ id: 'SectionBecomeHost.step2.description' })}</p>
              </div>
            </div>
            <div className={css.step}>
              <GiConfirmed size={20} color="#0d31f2" />

              <div className={css.stepInfo}>
                <h3>{intl.formatMessage({ id: 'SectionBecomeHost.step3.title' })}</h3>
                <p>{intl.formatMessage({ id: 'SectionBecomeHost.step3.description' })}</p>
              </div>
            </div>
          </div>
          <PrimaryButton onClick={handleClick}>
            {intl.formatMessage({ id: 'SectionBecomeHost.button' })}
          </PrimaryButton>
        </div>
        <div className={css.becomeHostEnd}>
          <img
            src="https://sharetribe-assets.imgix.net/67aa3ff3-c927-4d8d-9d86-c588de1d10c4/raw/43/ff0ac1dd7027e2ac35f1fbb45b5f84cead055d?auto=format&crop=edges&fit=crop&h=800&w=800&s=ab9d01b312d78757b44f5d8f720eb432"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default SectionBecomeHost;
